import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type {
  EditAddressBookInput,
  EditAddressBookResponse,
} from '@/types/address-book';

const fetcher = async (
  key: string,
  { arg }: { arg: EditAddressBookInput }
): Promise<EditAddressBookResponse> =>
  await denApi.patch<EditAddressBookResponse, EditAddressBookInput>(key, arg);

export function useEditAddressBook(
  swrOptions?: SWRMutationConfiguration<
    EditAddressBookResponse,
    Error,
    string,
    EditAddressBookInput
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    EditAddressBookResponse,
    Error,
    string,
    EditAddressBookInput
  >('organization/address-book', fetcher, swrOptions);

  return {
    editAddressBook: trigger,
    isLoading: isMutating,
    error,
  };
}
